import { Search, Download } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from './Button'
import { cn } from '@/shared/utils'

interface FilterOption { value: string; label: string }
interface Filter { type: 'select' | 'date'; label: string; value: string; onChange: (v: string) => void; options?: FilterOption[] }
interface Props { search?: { value: string; onChange: (v: string) => void; placeholder?: string }; filters?: Filter[]; onExport?: () => void; className?: string }

export function FilterBar({ search, filters, onExport, className }: Props) {
  const { t } = useTranslation()
  return (
    <div className={cn('flex flex-wrap items-center gap-3 mb-5', className)}>
      {search && (
        <div className="relative flex-1 min-w-48">
          <Search size={14} className="absolute start-3 top-1/2 -translate-y-1/2 text-gray-400"/>
          <input value={search.value} onChange={e => search.onChange(e.target.value)} placeholder={search.placeholder || t('common.searchPlaceholder')} className="w-full ps-9 pe-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-400" />
        </div>
      )}
      {filters?.map((f, i) => f.type === 'select' ? (
        <select key={i} value={f.value} onChange={e => f.onChange(e.target.value)} className="px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-400 bg-white min-w-32">
          <option value="">{f.label}</option>
          {f.options?.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      ) : (
        <label key={i} className="flex flex-col gap-1">
          <span className="text-[12px] text-gray-400 font-semibold uppercase tracking-wide px-0.5">{f.label}</span>
          <input type="date" value={f.value} onChange={e => f.onChange(e.target.value)} className="px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-400 bg-white" />
        </label>
      ))}
      {onExport && <Button variant="outline" size="sm" icon={<Download size={13}/>} onClick={onExport}>{t('common.export')}</Button>}
    </div>
  )
}
